import axiosInstance from '../../../axiosInstance'
import { setLockedTourId } from '../services/authSession'

// Vue-specific API service
export const api = {
  // Session auth endpoints for code-protected tours
  async loginWithCode(code) {
    const formData = new FormData()
    formData.append('code', code)
    return axiosInstance.post(process.env.CLIENT_API_URL + '/login', formData)
  },

  async refreshSession(refreshToken) {
    return axiosInstance.post(process.env.CLIENT_API_URL + '/auth/refresh', {
      refresh_token: refreshToken
    })
  },

  async logoutSession() {
    return axiosInstance.post(process.env.CLIENT_API_URL + '/auth/logout')
  },

  // Tour settings
  async getTourSettings(activeTour) {
    const reservedFirstSegments = new Set(['qr', 'point', 'tours', 'info', 'list', 'points', 'not-found', 'point-error'])
    const isValidTourId = activeTour && !reservedFirstSegments.has(String(activeTour))

    const headers = {
      'X-Tour-Host': location.host,
      ...(isValidTourId && { "X-Tour-Id": activeTour }),
    }
    const response = await axiosInstance.get(process.env.CLIENT_API_URL + '/settings', { headers })
    const resolvedTourId = response?.data?.id ?? activeTour
    if (resolvedTourId) {
      setLockedTourId(resolvedTourId)
    }
    return response
  },

  // Tour list (for Tours page)
  async fetchTourList() {
    return axiosInstance.get(process.env.CLIENT_API_URL + '/tours')
  },

  // Get point data
  async getPoint(pointId, tourId = null) {
    const headers = {}
    if (tourId) {
      headers["X-Tour-Id"] = tourId
    }
    
    return axiosInstance.get(
      `${process.env.CLIENT_API_URL}/point/${pointId}`,
      { headers }
    )
  },
  
  // Get tour point data (same as React TourPoint component)
  async getTourPoint(tourPointId, tourId = null, language = 'en') {
    const headers = {}
    if (tourId) {
      headers["X-Tour-Id"] = tourId
    }
    
    const params = { lang: language }
    
    return axiosInstance.get(
      `${process.env.CLIENT_API_URL}/tour-points/${tourPointId}`,
      { params, headers }
    )
  },
  
  // Get page content
  async getContent(pageId, language = 'en', tourId = null) {
    const headers = {}
    if (tourId) {
      headers["X-Tour-Id"] = tourId
    }
    
    const params = { lang: language }
    
    return axiosInstance.get(
      `${process.env.CLIENT_API_URL}/page/${pageId}`,
      { params, headers }
    )
  },
  
  // Submit quiz answers
  async submitQuiz(pointId, answers, tourId = null) {
    const headers = {}
    if (tourId) {
      headers["X-Tour-Id"] = tourId
    }
    
    return axiosInstance.post(
      `${process.env.CLIENT_API_URL}/quiz/${pointId}`,
      answers,
      { headers }
    )
  },
  
  // Submit variables
  async submitVariables(pointId, variables, tourId = null) {
    const headers = {}
    if (tourId) {
      headers["X-Tour-Id"] = tourId
    }
    
    return axiosInstance.post(
      `${process.env.CLIENT_API_URL}/variables/${pointId}`,
      variables,
      { headers }
    )
  },

  // Tour points
  async getTourPoints(activeTour) {
    const headers = {
      ...(activeTour && {
        "X-Tour-Id": activeTour
      }),
    }
    return axiosInstance.get(process.env.CLIENT_API_URL + "/tour-points", { headers })
  },

  // Routing API for outdoor navigation
  async getRoute(profile, coordinates, options = {}) {
    const queryParams = new URLSearchParams({
      overview: options.overview || 'full',
      geometries: options.geometries || 'geojson',
      steps: options.steps || 'true',
      ...options
    })
    
    const url = `${process.env.CLIENT_API_URL}/routing/v1/${profile}/${coordinates}?${queryParams}`
    return axiosInstance.get(url)
  },

  // Send connectbox message
  async sendConnectboxMessage(connectboxId, tourId = null) {
    const headers = {}
    if (tourId) {
      headers["X-Tour-Id"] = tourId
    }

    const formData = new FormData()
    formData.append("connectbox", connectboxId)

    // Send the connectbox message
    return axiosInstance.post(
      process.env.CLIENT_API_URL + "/connectbox",
      formData,
      { headers }
    )
  },

  // Send connectbox message
  async sendConnectboxCommand(commandId, tourId = null) {
    const headers = {}
    if (tourId) {
      headers["X-Tour-Id"] = tourId
    }

    const formData = new FormData()
    formData.append("command_id", commandId)

    // Send the connectbox message
    return axiosInstance.post(
        process.env.CLIENT_API_URL + "/connectbox",
        formData,
        { headers }
    )
  }
}

export default api 